import { IFilmOrderListItem } from '../Entities';

export const FilmStatusAll = -1;

export function filterByFilmStatus(
    orders: IFilmOrderListItem[],
    filmStatus: number | string
): IFilmOrderListItem[] {
    const selected = Number(filmStatus);

    if (selected === FilmStatusAll) {
        return orders;
    }

    return orders.filter((x) => x.filmStatus.value === selected);
}
